/*=========================================================================================
	File Name: store.js
	Description: Vuex store
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)


import moduleAuth from './auth/moduleAuth.js'
import moduleECommerce from './eCommerce/moduleECommerce.js'
import moduleRole from './role/moduleRole.js'
import moduleCustomer from './customer/moduleCustomer.js'
import moduleStorehouse from "./storehouse/moduleStorehouse.js"
import moduleStock from './stock/moduleStock.js'
import moduleStockTracking from './stockTracking/moduleStockTracking'
import moduleUser from "./user/moduleUser"
import moduleOrder from "./order/moduleOrder"
import moduleTemplate from "./templates/moduleTemplates.js"
import moduleReports from './report/moduleReports.js'

export default new Vuex.Store({
	getters,
	mutations,
	state,
	actions,
	modules: {
		customer: moduleCustomer,
		auth: moduleAuth,
		eCommerce: moduleECommerce,
		role: moduleRole,
		storehouse: moduleStorehouse,
		stock: moduleStock,
		stockTracking: moduleStockTracking,
		user: moduleUser,
		order: moduleOrder,
		template: moduleTemplate,
		report: moduleReports
	},
	strict: process.env.NODE_ENV !== 'production'
})
